"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CccisdFieldWrapper = _interopRequireDefault(require("../CccisdFieldWrapper"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _format = _interopRequireDefault(require("date-fns/format"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _default = exports["default"] = function _default(props) {
  var field = props.field,
    form = props.form,
    placeholder = props.placeholder,
    showTimeSelect = props.showTimeSelect,
    showMonthYearPicker = props.showMonthYearPicker,
    reactDatepickerProps = props.reactDatepickerProps;
  var onChange = function onChange(date) {
    var value = date ? (0, _format["default"])(date, getDateStringFormat()) : null;
    form.setFieldValue(field.name, value);
  };
  var getDateFormat = function getDateFormat() {
    if (showTimeSelect) {
      return 'MM/dd/yyyy h:mm a';
    }
    if (showMonthYearPicker) {
      return 'MM/yyyy';
    }
    return 'MM/dd/yyyy';
  };
  var getDateStringFormat = function getDateStringFormat() {
    if (showTimeSelect) {
      return 'YYYY-MM-DD HH:mm:ss';
    }
    if (showMonthYearPicker) {
      return 'YYYY-MM';
    }
    return 'YYYY-MM-DD';
  };
  return /*#__PURE__*/_react["default"].createElement(_CccisdFieldWrapper["default"], props, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], _extends({
    className: "form-control form-control-sm",
    showTimeSelect: showTimeSelect,
    showMonthYearPicker: showMonthYearPicker,
    dateFormat: getDateFormat(),
    placeholderText: placeholder
  }, reactDatepickerProps, {
    selected: field.value,
    onChange: onChange
  }))));
};